import PropTypes from 'prop-types';

import Presenter from 'utils/PropTypesPresenter';

export default new Presenter({
  link: PropTypes.string,
  name: PropTypes.string,
});
